function httpProviderConfig($httpProvider) {
  $httpProvider.interceptors.push([
    '$q',
    '$injector',
    'LocalStoreService',
    function ($q, $injector, LocalStoreService) {
      return {
        request: function (config) {
          // console.log('are we saending the token even if not logged? fix it');

          const token = LocalStoreService.token('cu') || null;

          config.headers.Authorization = 'Bearer ' + token;
          config.headers.CLIENT_ID = new Date().toUTCString();

          return config;
        },
        responseError: function (response) {
          if (response.status === 401) {
            LocalStoreService.unset('cu');
            // console.log('httpProviderConfig login');

            // $injector.get('$state').go('anon.login');
            // $location.path('/login');
          }

          return $q.reject(response);
        },
      };
    },
  ]);

  $httpProvider.defaults.headers.post['Content-Type'] = 'application/json';
  $httpProvider.useApplyAsync(true);
}

httpProviderConfig.$inject = ['$httpProvider'];

export default httpProviderConfig;
